<script>
import Layout from "@layouts/form";
import ProjetoExtrato from "@forms/ProjetoExtrato";

export default {
  page: {
    title: "Detalhes | ProjetoExtrato"
  },
  components: { Layout, ProjetoExtrato },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "ProjetoExtrato",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "ProjetoExtrato",
          href: "/ProjetoExtrato"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ProjetoExtrato :editable="editable"></ProjetoExtrato>
    </div>
  </Layout>
</template>
